import { NaverLogin, NaverMobileLogin } from '../../assets';
import LoginNaver from 'react-login-by-naver';
import SocialLoginBtn from './SocialLoginBtn';
import { SocialLoginPlatformEnum } from './type';

export default function NaverLoginBtn({
  afterSocialLoginSuccess,
  dataSocial,
  variant = 'legacy',
  recentLogin,
}) {
  const isRecent = variant === 'draft' && recentLogin === dataSocial;
  const handleLogin = (naverUser) => {
    afterSocialLoginSuccess({
      type: SocialLoginPlatformEnum.NAVER,
      socialId: naverUser.id,
      email: naverUser.email,
    });
  };

  return (
    <div
      data-social={dataSocial}
      className={isRecent ? 'login-social-wrap--recent' : undefined}
    >
      <LoginNaver
        clientId={process.env.REACT_APP_NAVER_CLIENT_ID}
        callbackUrl={process.env.REACT_APP_CALLBACK_URL}
        render={(props) => (
          <>
            <SocialLoginBtn
              onClick={props.onClick}
              backgroundColor="bg-[#03C75A]"
              fontColor="text-white"
              additionalStyle={undefined}
              icon={
                variant === 'draft' ? (
                  <NaverLogin width={24} height={24} />
                ) : (
                  <>
                    <NaverLogin className="hidden md:block" width={24} />
                    <NaverMobileLogin className="block md:hidden" />
                  </>
                )
              }
              text="naver"
              variant={variant}
            />
          </>
        )}
        onSuccess={(result) => {
          handleLogin({ id: result.id, type: 'naver', email: result.email });
        }}
        onFailure={() => console.error('failed')}
      />
    </div>
  );
}
